// import serviceIcon1 from "../Assets/ship1.png";
// import serviceIcon2 from "../Assets/ship2.jpg";
// import serviceIcon3 from "../Assets/ship3.webp";
// import serviceIcon4 from "../Assets/ship4.webp";
// import serviceIcon5 from "../Assets/ship5.webp";
// import serviceIcon6 from "../Assets/ship6.jpg";
import serviceIcon1 from "../Assets/image1.jpeg";
// import serviceIcon2 from "../Assets/image2.jpeg";
import serviceIcon2 from "../Assets/marinelogistics.jpeg";
import serviceIcon3 from "../Assets/image3.jpeg";
import serviceIcon4 from "../Assets/ship6.jpg";
import serviceIcon11 from "../Assets/image11.webp";
// import serviceIcon6 from "../Assets/image5.jpeg";

const ServiceData = [
    {
        title: "Alternative Crude Evacuation",
        description: "We specialize in Alternative Crude Evacuation (ACE) services, offering a robust logistics-driven solution to the challenges posed by compromised pipeline infrastructure in Nigeria.",
        image: serviceIcon3,
        href: "/services/alternative-crude-evacuation"
    },
    {
        title: "Marine Procurement",
        description: "From vessel provision to port discharge supervision, Alchemie Marine delivers comprehensive chartering and logistics solutions across West Africa. ",
        image: serviceIcon1,
        href: "/services/procurement-logistics",
    },
    {
        title: "Marine Logistics",
        description: "Our logistics operations are powered by deep operational expertise and cutting-edge technology, delivering secure, efficient, and cost-effective solutions",
        image: serviceIcon2,
        href: "/services/marine-logistics",
    },
    {
        title: "Marine Security and Support Services",
        description: "We proudly collaborate with Nigerian Navy personnel to drive innovation, ensure maritime security, and achieve excellence across the marine industry.",
        image: serviceIcon4,
        href: "/services/security-and-support",
    },
    {
        title: "Marine Consultancy",
        description: "With over a decade of expertise, Alchemie Marine delivers specialized consultancy across the marine sector—offering project advisory, quality assurance and control, project management and monitoring, agency representation, and technical inspection services.",
        image: serviceIcon11,
        href: "/services/consultancy-service",
    },
];

export default ServiceData;